<router-outlet></router-outlet>
<dx-popup
        class="popup"
        [showTitle]="true"
        [dragEnabled]="true"
        [closeOnOutsideClick]="true"
        [(visible)]="isModalVisible"
        [contentTemplate]="'content'"
        (onHiding)="resetModal($event)"
        >
        <div *dxTemplate="let data of 'content'" class="popover-content">
            <p class="yellow-text" [innerHTML]="upcomingEvents"></p>
        </div>
</dx-popup>
